'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { MediaQuery } from '@s7/base';
import { Stack } from '@s7/layout';
import { Typography, Link, Divider } from '@s7/ui';
import { useLinkOverride } from '../../../../../common/ResourceLink/LinkOverride.context.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var defaultHintProps = {
    size: "xs2",
    color: "text.mediumHigh"
};
var defaultTitleProps = {
    variant: "heading",
    size: "xs1",
    color: "text.mediumHigh"
};
var defaultLinkProps = {
    size: "md1",
    color: "text.mediumHigh",
    underline: "hover",
    weight: "semibold",
    variant: "heading",
    breakpoints: {
        "sm1.up": {
            variant: "text",
            weight: "semibold",
            color: "text.mediumHigh"
        }
    }
};
var rootStyles = function(theme) {
    var _obj;
    return _obj = {}, _obj[theme.fn.up("sm1")] = {
        flexDirection: "row"
    }, _obj;
};
var PrimaryPhone = function(props) {
    var hint = props.hint, title = props.title, link = props.link, linkProps = props.linkProps, hintProps = props.hintProps, titleProps = props.titleProps, onClick = props.onClick;
    var unpackLink = useLinkOverride();
    if (!hint && !title && !link) {
        return null;
    }
    return /*#__PURE__*/ jsxs(Stack, {
        spacing: 24,
        children: [
            /*#__PURE__*/ jsxs(Stack, {
                breakpoints: {
                    "sm1.up": {
                        justify: "flex-start",
                        align: "end",
                        spacing: 24
                    }
                },
                justify: "space-between",
                spacing: 8,
                sx: rootStyles,
                children: [
                    (hint || title) && /*#__PURE__*/ jsxs(Stack, {
                        spacing: 0,
                        children: [
                            hint && /*#__PURE__*/ jsx(Typography, _extends({}, defaultHintProps, hintProps, {
                                children: hint
                            })),
                            title && /*#__PURE__*/ jsx(Typography, _extends({}, defaultTitleProps, titleProps, {
                                children: title
                            }))
                        ]
                    }),
                    link && /*#__PURE__*/ jsx(Link, _extends({}, defaultLinkProps, linkProps, unpackLink(link), {
                        onClick: onClick,
                        children: link == null ? void 0 : link.title
                    }))
                ]
            }),
            /*#__PURE__*/ jsx(MediaQuery, {
                query: "sm1.up",
                styles: {
                    display: "none"
                },
                children: /*#__PURE__*/ jsx(Divider, {})
            })
        ]
    });
};

export { PrimaryPhone };
